export * from './link';
export { createOperation, makePromise, toPromise, fromPromise, fromError, } from './linkUtils';
import Observable from 'zen-observable-ts';
export { Observable };
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /home/alarmplan/staging/shared/frontend/~/apollo-link/lib/index.js
// module id = 56
// module chunks = 0